import { Col, Row } from 'react-bootstrap';
import './AuthPageWrapper.css';
import LanguageSwitcher from '../../../localization/LanguageSwitcher';
import { AuthGraphics } from '../AuthGraphics';
import { SusyLogo } from '../../icons';
import { Link } from 'react-router-dom';
import { unauthenticatedPaths } from '../../../../router/constants/route-paths';
import { useEffect } from 'react';

interface IProps {
    children?: JSX.Element;
    title?: string;
    subtitle?: string;
    body?: string;
    wideForm?: boolean;
    dataTestId?: string;
}

export const AuthPageWrapper = (props: IProps) => {
    const { title, subtitle, wideForm, dataTestId, children } = props;

    const addCssClassToBodyElement = (customClassName: string) => {
        document.body.classList.add(customClassName);
    };

    const removeCssClassFromBodyElement = (customClassName: string) => {
        document.body.classList.remove(customClassName);
    };

    useEffect(() => {
        addCssClassToBodyElement('susy-auth-page');

        return () => {
            removeCssClassFromBodyElement('susy-auth-page');
        };
    }, []);

    const renderLogo = () => {
        return (
            <div className='susy-logo-wrapper'>
                <Link to={unauthenticatedPaths.home}>
                    <div className='susy-logo'>
                        <SusyLogo />
                    </div>
                </Link>
            </div>
        );
    };

    return (
        <>
            {renderLogo()}
            <Row
                className={
                    'auth-page-wrapper justify-content-between m-0 susy-mb-2'
                }
                data-testid={dataTestId}
            >
                <Col xs={12} lg={5} className={'auth-page-content'}>
                    <div className='flex-fill'>
                        <div>
                            <div
                                className={`auth-page-title-subtitle text-center ${
                                    wideForm ? 'auth-page-form-wide' : ''
                                }  `}
                            >
                                {title && (
                                    <div className='auth-page-title'>
                                        {title}
                                    </div>
                                )}
                                {subtitle && (
                                    <div className='auth-page-subtitle'>
                                        {subtitle}
                                    </div>
                                )}
                            </div>
                            <div
                                className={`auth-page-form ${
                                    wideForm ? 'auth-page-form-wide' : ''
                                }  `}
                            >
                                {children}
                            </div>
                        </div>
                        <div className={'d-flex justify-content-center mt-5'}>
                            <LanguageSwitcher />
                        </div>
                    </div>
                </Col>
                <Col className={'auth-page-graphics d-flex'} lg={7}>
                    <AuthGraphics />
                </Col>
            </Row>
        </>
    );
};
